// extracted by mini-css-extract-plugin
module.exports = {"slider__wrapper":"S_dv","slider__element":"S_dw","itemSlider":"S_dx","itemSlider__slideWrapper":"S_dy","itemSlider__pagination":"S_dz","activeSlide":"S_dB"};